import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { GlobalActions } from '../../model';
import { OfferingDocumentGroup } from '../../model/documents/offering-document-group';
import {
  downloadOfferDocuments,
  getOfferingDocumentsState,
  offeringDocumentsActions,
} from '../../store/features/documents';
import { messagesForOfferingDocumentsError } from '../../store/features/documents/offerings/offerings-utils';
import { useAppDispatch, useAppSelector } from '../redux';

export interface OfferingDocumentsTabLogic {
  offerings: OfferingDocumentGroup[];
  isRequestLoading: boolean;
}

export const useOfferingDocumentsTabLogic = (
  globalActions: GlobalActions
): OfferingDocumentsTabLogic => {
  const { showToast, closeToast } = globalActions;
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const { offerings, offeringsRequestStatus, offeringsError }:any = useAppSelector(
    getOfferingDocumentsState
  );
  const [downloadOfferingsCallingRequest, setDownloadOfferingsCallingRequest] =
    useState(0);

  useEffect(() => {
    if (
      downloadOfferingsCallingRequest === 0 &&
      (!offerings || offerings.length === 0) &&
      offeringsRequestStatus !== 'loading'
    ) {
      setDownloadOfferingsCallingRequest(downloadOfferingsCallingRequest + 1);
      dispatch(downloadOfferDocuments());
    }
  }, [
    dispatch,
    offerings,
    offeringsRequestStatus,
    downloadOfferingsCallingRequest,
  ]);

  useEffect(() => {
    if (offeringsError) {
      const errorMessages = messagesForOfferingDocumentsError(offeringsError);
      showToast({
        type: 'error',
        title: formatMessage(errorMessages.title),
        description:
          errorMessages.description && formatMessage(errorMessages.description),
        close: closeToast,
      });
      dispatch(offeringDocumentsActions.clearError());
    }
  }, [dispatch, offeringsError, closeToast, formatMessage, showToast]);

  return {
    offerings,
    isRequestLoading: offeringsRequestStatus === 'loading',
  };
};
